export default function isValidLinkedinUrlChatbot(url) {
  const regex = /^https?:\/\/(([\w]{2,3}\.)?linkedin\.com)\/(pub|in|profile)\/[^\s/?#&]+\/?(?:[^\s]*)?$/i;
  return regex.test(url);
}
